const sendEmail = async ({ email, result }) => {
  const url = '/api/survey/email';

  let data = {
    email,
    result,
  };

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const results = await response.json();
  return results;
};

export default sendEmail;
